import { render } from "./createpurchasereturn.vue?vue&type=template&id=9966d694"
import script from "./createpurchasereturn.vue?vue&type=script&lang=js"
export * from "./createpurchasereturn.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__